module.exports = __webpack_public_path__ + "static/img/14046B_1_2_C_20210606_LC.08e1418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14046B_1_2_C_20210606_LC.png
// module id = P/jk
// module chunks = 0